export const NAME = "Ronan Fegan"
export const GITHUB = "https://github.com/ronan-f"
export const LINKEDIN = "https://www.linkedin.com/in/ronanfegan/"
export const ANIMATION_DURATION = 800
